import * as getters from "../../baseQuestion/textarea/store/getters";
import * as mutations from "../../baseQuestion/textarea/store/mutations";
import * as actions from "../../baseQuestion/textarea/store/actions";
import { state as base_state } from "../../baseQuestion/textarea/store/state";

function state() {
	return base_state();
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
